export default "__VITE_ASSET__f6c39898__"